import React from 'react'
import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'
import { Help } from '../common/Help'
import { CheckIcon } from './CheckIcon'

type Props = {
  list: {
    [k: string]: {
      text?: React.ReactNode
      help?: string
      helpLink?: string
      bool?: boolean
      indent?: boolean
      extraClassName?: string
      isHidden?: boolean
    }
  }
  className?: string
}

export const DescriptionList: React.FC<Props> = (props) => {
  return (
    <dl className={props.className}>
      {Object.entries(props.list)
        .filter(([_, v]) => v.isHidden !== true)
        .map(([k, v], i) => (
          <div
            key={i}
            css={css`
              display: flex;
              word-break: break-all;
              font-size: 14px;
              line-height: 1.3;
              color: ${colors.black30};
              margin-bottom: 0.7rem;
            `}
          >
            <dt
              css={css`
                flex: 1;
                font-weight: ${font.weight.bold};
                padding-left: ${v.indent && '12px'};
                margin-right: ${v.indent && '-12px'};
              `}
            >
              {k}
              {v.help && <Help linkTo={v.helpLink}>{v.help}</Help>}
            </dt>
            <dd
              css={css`
                flex: 2;
                white-space: pre-wrap;
              `}
              className={v.extraClassName}
            >
              {v.bool ? <CheckIcon /> : v.text}
            </dd>
          </div>
        ))}
    </dl>
  )
}
